const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)

export default [
  {
    path: 'positions',
    component: {
      template: '<router-view></router-view>'
    },
    name: 'Positions',
    meta: {
      title: 'Должности',
      menuKey: 'schedule',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']
    },
    children: [
      {
        path: '',
        component: _import('positions/components/list'),
        name: 'Positions.list',
        meta: {
          title: 'Список должностей',
          menuKey: 'schedule',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        },
      },
      {
        path: 'create',
        component: _import('positions/components/create'),
        name: 'Positions.create',
        meta: {
          title: 'Новая должность',
          menuKey: 'schedule',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: ':id/edit',
        component: _import('positions/components/edit'),
        name: 'Positions.edit',
        meta: {
          title: 'Редактировать должность',
          menuKey: 'schedule',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: ':id',
        component: _import('positions/components/info'),
        name: 'Positions.info',
        meta: {
          title: 'Информация о должности',
          menuKey: 'schedule',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
    ]

  }
]



// WEBPACK FOOTER //
// ./src/modules/positions/routes.js